import React from 'react';

export type AttributesTableProps = {
  children?: React.ReactNode;
};

export const AttributesTable = ({ children }: AttributesTableProps) => (
  <dl className="table">{children}</dl>
);
